module.exports = __webpack_public_path__ + "static/media/care3.7e56ced1.webp";